module.exports = __webpack_public_path__ + "static/media/Molex_logo_white.c204bb36.png";